import { useCallback } from 'react';
import { PAGE_TYPE } from '@/app/common/pageType';
import { useCommonClient } from '@/app/common/commonClientProvider';
import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import getSearchParams from '@/app/components/search/common/getSearchParams';
import { URLParameters } from '@/app/common/urlParameters';
import { createChangeFlightLinkClickedPayload } from '@/app/common/starTrack/events/changeFlightLinkClicked.ts';

/**
 * Fires CHANGE_FLIGHT_LINK_CLICKED for the DP-evolution layout. Derives the current page from the
 * live URL at call time so components shared across Hotel Detail and Flight Detail (e.g. the mobile
 * trip-overview modal) always report the correct page without needing to know where they are rendered.
 */
export function useTrackChangeTransportLinkClicked() {
  const { starTrack } = useCommonClient();
  const { productDetailKey } = useInitialParams();

  return useCallback(() => {
    const searchParams = getSearchParams();
    const page = searchParams[URLParameters.PAGE_TYPE] === PAGE_TYPE.HOTEL_DETAIL ? 'Hotel Detail' : 'Flight Detail';
    starTrack.changeFlightLinkClicked(
      createChangeFlightLinkClickedPayload({
        searchId: searchParams[URLParameters.SEARCH_ID] || '',
        productDetailKey,
        page,
      })
    );
  }, [starTrack, productDetailKey]);
}
